import { find } from "@kluntje/js-utils/lib/dom-helpers";
import { SDENavigation } from "Components/sde-m-navigation/sde-m-navigation";

class NavigationService {
  private navigation: SDENavigation | null = null;

  constructor() {
    this.navigation = find<SDENavigation>(document.body, this.navigationId);
  }

  private get navigationId() {
    return "#sde-navigation";
  }

  public openNavigation() {
    this.navigation?.open();
  }

  public closeNavigation() {
    this.navigation?.close();
  }
}

export default new NavigationService();
